export default {
  SET_LOADING (state, payload) {
    state.loading = payload
  },

  setList (state, payload) {
    console.log('setList', payload)
    state.list = []
    state.list = [...payload]
  },

  setUnitList (state, { rootState }) {
    const list = []
    for (const i in state.list) {
      const unitList = []
      const object = state.list[i]
      // Search for the unit in the list
      const units = rootState.units.list.filter(item => object.units.includes(item.id))
      // If the unit is found, add it to the unitList
      if (units.length > 0) {
        for (const j in units) {
          const unit = units[j]
          unitList.push(unit)
        }
      }
      object.unitList = unitList
      object.unitsIds = object.units
      // Add groups names to object
      const groups = rootState.groups.list.filter(item => object.groups.includes(item.id))
      const groupsList = []
      for (const j in groups) {
        const group = groups[j]
        groupsList.push(group)
      }
      object.groupsList = groupsList
      object.groupsIds = object.groups
      // Add the object to the list
      list.push(object)
    }
    state.list = list
  },

  newItem (state, payload) {
    state.list.push(payload)
  },

  updateItem (state, payload) {
    const list = [...state.list]
    for (let i = 0; i < list.length; i++) {
      if (list[i].id.toString() === payload.id.toString()) {
        list[i] = Object.assign({}, payload)
      }
    }

    state.list = []
    state.list = [...list]
  },

  deleteItem (state, id) {
    const list = state.list.filter(item => item.id.toString() !== id.toString())
    state.list = []
    state.list = [...list]
  },

  toggle () {}
}